module.exports = vue_library;


//////////////////
// WEBPACK FOOTER
// external "vue_library"
// module id = hWmm
// module chunks = 2